import React from "react";

function Footer(props) {
  return (
    <footer>
      <div className="footer-container">
        <p>
          Projet Realisé par <span className="asid">Asid</span> inspiré de
          Donkey-Geek -2023
        </p>{" "}
        <p>
          Les icones Wolverine, Iron-man,Spiderman,Batman proviennent de
          iconfinder.com
        </p>
      </div>
    </footer>
  );
}

export default Footer;
